// ABOUTME: Note shown while editing a machine translation of someone else's text.
// ABOUTME: Saving keeps the edit as written, so the editor's language becomes the original (WA-762).

import { useTranslation } from "react-i18next"
import { AlertTriangleIcon } from "@shared/icons"

interface IProps {
  className?: string
}

export const L10nEditWarning = ({ className = "" }: IProps) => {
  const { t } = useTranslation()

  return (
    <div className={`mt-1 flex items-start gap-1 text-xs text-[#8E4B10] ${className}`}>
      <span className="mt-[2px] shrink-0">
        <AlertTriangleIcon size={12} />
      </span>
      <span className="wrap-anywhere">{t("l10n.editingTranslation")}</span>
    </div>
  )
}

export default L10nEditWarning
